export default "__VITE_ASSET__Bp16xz_3__"